import Crud from '../components/ScheduleWorkstations/Crud.vue'
import Entity from '../components/ScheduleWorkstations/Add.vue'
import View from '../components/ScheduleWorkstations/View.vue'

let routes = {
  path: '/schedule_workstations',
  component: resolve => require(['../components/layout/App'], resolve),
  children: [
    {
      path: '/schedule_workstations',
      name: 'Agendamento de Workstation',
      component: Crud,
    },
    {
      path: '/schedule_workstations/add',
      name: 'Adicionar reserva de workstation',
      component: Entity,
    },
    {
      path: '/schedule_workstations/view/:id?',
      name: 'Visalizar reserva de workstation',
      component: View,
    },
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/schedule_workstations.js